/* ============================================================
   KROQ MATCH — interface

   Le calcul vit dans `kroq-match-engine.js`, qui ne connaît ni le DOM
   ni le stockage. Ce fichier-ci ne fait que trois choses : conduire le
   questionnaire, retenir le profil, afficher les résultats.

   Aucune dépendance, aucun appel réseau, aucun envoi du profil à qui
   que ce soit. Le chien reste dans le navigateur de son maître.
   ============================================================ */
(function () {
  'use strict';

  var E = window.KroqMatchEngine;
  if (!E) return;

  var KEY = 'kroq_match_profile_v1';
  var MAX_AGE_DAYS = 180;

  /* ── Persistance ─────────────────────────────────────────
     Clé versionnée : un changement de forme du profil n'a pas à
     composer avec les anciennes données, il les ignore. */
  function loadProfile() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.v !== 1) return null;
      if (data.t && (Date.now() - data.t) / 86400000 > MAX_AGE_DAYS) {
        localStorage.removeItem(KEY);
        return null;
      }
      return data.profile || null;
    } catch (e) {
      return null;
    }
  }

  function kroqTrack(eventName, data = {}) {
  try {
    // Shopify Customer Events
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === "function"
    ) {
      Shopify.analytics.publish(`kroq_match:${eventName}`, data);
    }

    // Microsoft Clarity
    if (typeof window.clarity === "function") {
      window.clarity("event", "kroq_match_" + eventName);

      if (data.step_number != null) {
        window.clarity(
          "event",
          "kroq_match_step_" + String(data.step_number)
        );
      }

      if (data.product_handle) {
        window.clarity(
          "set",
          "kroq_product",
          String(data.product_handle)
        );
      }
    }
  } catch (error) {
    console.warn("[Kroq Match tracking]", error);
    }
  }
  function saveProfile(profile) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({
        v: 1,
        t: Date.now(),
        profile: profile
      })
    );
  } catch (e) {
    /* Navigation privée, quota plein :
       le quiz reste utilisable. */
  }
  }
  function clearProfile() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  /* ── Analytique ──────────────────────────────────────────
     Un évènement DOM, et rien d'autre. Aucun détail du chien n'est
     transmis : ni race, ni poids, ni âge. */
  function track(name, payload) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: payload || {} }));
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      }
    } catch (e) {}
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Échelle sur 5, accessible ───────────────────────────
     Les pastilles sont décoratives ; la valeur est portée par un texte
     lisible par tous, jamais par la seule couleur ni la seule forme. */
  function scale(label, value) {
    if (value == null) return '';
    var n = Math.round(value);
    var dots = '';
    for (var i = 1; i <= 5; i++) dots += i <= n ? '●' : '○';
    return (
      '<div class="km-scale">' +
      '<span class="km-scale__label">' + esc(label) + '</span>' +
      '<span class="km-scale__dots" aria-hidden="true">' + dots + '</span>' +
      '<span class="km-scale__value">' + n + '<span class="km-scale__max">/5</span></span>' +
      '<span class="visually-hidden">' + esc(label) + ' : ' + n + ' sur 5</span>' +
      '</div>'
    );
  }

  /* ════════════════════════════════════════════════════════
     QUIZ
     ════════════════════════════════════════════════════════ */
  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-km-step]'));
    if (!steps.length) return null;

    var progress = root.querySelector('[data-km-progress]');
    var bar = root.querySelector('[data-km-bar]');
    var btnNext = root.querySelector('[data-km-next]');
    var btnBack = root.querySelector('[data-km-back]');
    var errorBox = root.querySelector('[data-km-error]');
    var current = 0;
    var started = false;
    var trackedSteps = {};

    function trackStep(index) {
      var stepNumber = index + 1;
      if (trackedSteps[stepNumber]) return;
      trackedSteps[stepNumber] = true;

      kroqTrack("step", {
        step_number: stepNumber,
        total_steps: steps.length
      });
    }

    function show(i) {
      current = Math.max(0, Math.min(steps.length - 1, i));
      steps.forEach(function (s, n) { s.hidden = n !== current; });
      if (progress) progress.textContent = (current + 1) + ' / ' + steps.length;
      if (bar) bar.style.setProperty('--km-progress', ((current + 1) / steps.length) * 100 + '%');
      if (btnBack) btnBack.hidden = current === 0;
      /* `data-km-next` est un drapeau vide : le libellé vit dans
         `data-km-next-label`, sans quoi le bouton se viderait. */
      if (btnNext) {
        btnNext.textContent = current === steps.length - 1
          ? (btnNext.dataset.kmLast || 'Voir ses Kroq Match')
          : (btnNext.dataset.kmNextLabel || 'Continuer');
      }
      if (errorBox) { errorBox.textContent = ''; errorBox.hidden = true; }

      /* Le focus suit l'étape, sinon la navigation clavier reste
         bloquée en haut du formulaire. */
      var h = steps[current].querySelector('legend, h2, h3');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }

    function fail(msg) {
      if (!errorBox) return false;
      errorBox.textContent = msg;
      errorBox.hidden = false;
      errorBox.focus({ preventScroll: true });
      return false;
    }

    /* Seul le poids est exigé : c'est la donnée qui porte la sécurité. */
    function validate() {
      var step = steps[current];
      var weight = step.querySelector('[name="km-weight"]');
      if (weight && !weight.value) return fail(weight.dataset.kmError || 'Indiquez son poids pour continuer.');
      if (weight && (parseFloat(weight.value) <= 0 || parseFloat(weight.value) > 120)) {
        return fail('Indiquez un poids compris entre 1 et 120 kg.');
      }
      return true;
    }

    function collect() {
      var get = function (n) { var el = root.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
      var checked = function (n) {
        var el = root.querySelector('[name="' + n + '"]:checked');
        return el ? el.value : '';
      };
      var ageVal = parseFloat(String(get('km-age')).replace(',', '.'));
      var unit = checked('km-age-unit') || 'annees';
      var months = isFinite(ageVal) ? (unit === 'mois' ? ageVal : ageVal * 12) : null;

      var acts = Array.prototype.slice
        .call(root.querySelectorAll('[name="km-activity"]:checked'))
        .map(function (c) { return c.value; });

      return {
        name: get('km-name') || null,
        breed: get('km-breed') || null,
        weightKg: get('km-weight'),
        ageMonths: months,
        energy: checked('km-energy') || null,
        chew: checked('km-chew') || null,
        activities: acts,
        playsAlone: !!root.querySelector('[name="km-alone"]:checked')
      };
    }

    root.addEventListener('change', function () {
      if (started) return;

      started = true;
      var source = root.dataset.kmSource || 'page';

      track('kroq_match_started', { source: source });
      kroqTrack("start", { source: source });
      trackStep(current);
    });

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        if (!validate()) return;

        if (current < steps.length - 1) {
          show(current + 1);
          trackStep(current);
          return;
        }

        var raw = collect();
        saveProfile(raw);

        var source = root.dataset.kmSource || 'page';

        track('kroq_match_completed', { source: source });

        kroqTrack("complete", {
          source: source,
          total_steps: steps.length
        });

        render(raw);
      });
    }
    if (btnBack) btnBack.addEventListener('click', function () { show(current - 1); });

    /* Entrée valide l'étape plutôt que d'envoyer le formulaire. */
    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.tagName !== 'BUTTON') {
        ev.preventDefault();
        if (btnNext) btnNext.click();
      }
    });

    show(0);
    return { show: show, collect: collect };
  }

  /* ════════════════════════════════════════════════════════
     RÉSULTATS
     ════════════════════════════════════════════════════════ */
  var CATALOGUE = null;
  var BREEDS = null;

  function catalogue() {
    if (CATALOGUE) return CATALOGUE;
    var raw = readJSON('kroq-match-products') || [];
    CATALOGUE = raw.map(E.normalizeProduct);
    return CATALOGUE;
  }

  function breeds() {
    if (BREEDS) return BREEDS;
    BREEDS = (readJSON('kroq-match-breeds') || []).map(E.normalizeBreed);
    return BREEDS;
  }

  function findBreed(handle) {
    if (!handle) return null;
    var all = breeds();
    for (var i = 0; i < all.length; i++) if (all[i].handle === handle) return all[i];
    return null;
  }

  function buildProfile(raw) {
    return E.normalizeDogProfile(raw, findBreed(raw && raw.breed));
  }

  /* Le client ne voit jamais `rawScore` : il voit `presentation`, qui
     n'écrit un pourcentage que si la donnée le soutient. Le classement,
     lui, continue de s'appuyer sur le score brut. */
  function badge(m) {
    var pr = m.presentation;
    if (pr.mode === 'score') {
      return '<span class="km-card__score">' + pr.publicScore +
        '<span class="km-card__pct">% de correspondance</span></span>';
    }
    if (pr.mode === 'level' || pr.mode === 'soft') {
      return '<span class="km-card__verdict">' + esc(pr.label) + '</span>';
    }
    return '';
  }

  /* Le prix vient formaté du Liquid (`money`), pour suivre le format de la
     boutique sans le réimplémenter ici. Sans lui, comparer deux
     recommandations obligeait à ouvrir deux fiches et à revenir. */
  function price(p) {
    if (!p.priceFormatted) return '';
    var txt = p.priceVaries ? 'À partir de ' + p.priceFormatted : p.priceFormatted;
    return '<span class="km-card__price">' + esc(txt) + '</span>';
  }

  function card(entry) {
    var p = entry.product;
    var m = entry.match;
    var pr = m.presentation;
    var why = m.matched.slice(0, 4).map(function (w) {
      return '<li>' + esc(w) + '</li>';
    }).join('');

    /* Une réserve réelle se dit sur la carte, pas seulement sur la
       fiche : sans elle, un produit noté « compatible » pourrait
       masquer un écart de mastication ou d'âge. */
    var caution = m.warnings.length
      ? '<span class="km-card__caution">' + esc(m.warnings[0]) + '</span>'
      : '';

    /* En mode `score`, le niveau coiffe déjà le chiffre. Dans les autres
       modes le libellé EST le badge : l'afficher deux fois le
       transformerait en insistance. */
    var head = pr.mode === 'score'
      ? '<span class="km-card__level km-card__level--' + m.level.key + '">' + esc(m.level.label) + '</span>'
      : '';

    return (
      '<li class="km-card">' +
      '<a class="km-card__link" href="' + esc(p.url) + '" data-km-product="' + esc(p.handle) + '">' +
      (p.image ? '<img class="km-card__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="300" height="300">' : '') +
      '<span class="km-card__body">' +
      head +
      '<span class="km-card__name">' + esc(p.shortTitle || p.title) + '</span>' +
      price(p) +
      badge(m) +
      (why ? '<ul class="km-card__why">' + why + '</ul>' : '') +
      caution +
      '</span></a></li>'
    );
  }

  function render(raw) {
    var host = document.querySelector('[data-km-results]');
    if (!host) return;
    var quiz = document.querySelector('[data-km-quiz]');

    var dog = buildProfile(raw);
    var products = catalogue();
    E.attachBreedRecommendations(products, findBreed(dog.breed));
    var ranked = E.rankProducts(dog, products);

    var breed = findBreed(dog.breed);
    var summary = [];
    if (breed && breed.name) summary.push(esc(breed.name));
    if (dog.weightKg) summary.push(Math.round(dog.weightKg) + ' kg');
    if (dog.ageMonths) {
      summary.push(dog.ageMonths < 24
        ? Math.round(dog.ageMonths) + ' mois'
        : Math.round(dog.ageMonths / 12) + ' ans');
    }

    /* Le prénom ne change aucun score. Il change ce que le maître lit,
       et c'est ce qui sépare un résultat d'un conseil. */
    var titre = dog.name ? 'Les Kroq Match de ' + esc(dog.name) : 'Ses Kroq Match';

    var html =
      '<div class="km-results__head">' +
      '<h2 class="km-results__title">' + titre + '</h2>' +
      (summary.length ? '<p class="km-results__profile">' + summary.join(' · ') + '</p>' : '') +
      '<div class="km-results__scales">' + scale('Énergie', dog.energy) + scale('Mastication', dog.chew) + '</div>' +
      '<button type="button" class="km-link" data-km-edit>Modifier le profil</button> ' +
      '<button type="button" class="km-link" data-km-reset>Effacer</button>' +
      '</div>';

    if (ranked.best.length) {
      html += '<h3 class="km-results__subtitle">Les plus adaptés</h3>' +
        '<ul class="km-grid" role="list">' + ranked.best.slice(0, 8).map(card).join('') + '</ul>';
    } else {
      /* Cas mesuré le 15 août 2026 : un chien de 45 kg qui mâche fort et
         aime tirer ne trouve aujourd'hui aucun produit franchement
         adapté dans le catalogue. Le dire est plus utile que de remplir
         l'écran, mais il ne faut pas laisser le maître sans suite : le
         reste du catalogue s'ouvre alors d'office, puisqu'il est tout ce
         qu'il y a à voir. */
      /* Deux etats vides distincts, et c'est important.

         Un chien de plus de 50 kg voit TOUT le catalogue ecarte : le
         plus gros jouet declare s'arrete a 50 kg. Lui repondre « voici
         le catalogue complet » alors que rien ne s'affiche serait faux.
         On dit alors clairement que la selection ne couvre pas encore
         son gabarit, plutot que de remplir la grille avec des produits
         que le moteur vient justement d'ecarter. */
      var nothingLeft = !ranked.others.length && (!ranked.packs || !ranked.packs.length);
      var who = dog.name ? esc(dog.name) : 'votre chien';
      if (nothingLeft) {
        html += '<p class="km-results__empty">La sélection Kroq ne contient pas encore de produit ' +
          'adapté au gabarit de ' + who + '. Les produits écartés sont listés ci-dessous ' +
          'avec la raison de leur exclusion, pour que vous puissiez juger vous-même.</p>';
      } else {
        html += '<p class="km-results__empty">Aucun produit ne ressort nettement pour le profil de ' +
          who + '. Voici le reste du catalogue, avec pour chaque produit ce qui correspond et ce qui ' +
          'ne correspond pas.</p>';
      }
    }

    /* Les packs à part : sans cela, un pack et ses trois composants
       occupent les quatre premières places sans rien apprendre. */
    if (ranked.packs && ranked.packs.length) {
      html += '<h3 class="km-results__subtitle">Ou en pack</h3>' +
        '<ul class="km-grid" role="list">' + ranked.packs.slice(0, 3).map(card).join('') + '</ul>';
    }

    /* Ce bloc s'intitulait « Autres produits adaptés à son profil » et
       s'affichait déplié. Mesuré le 15 août 2026 : il contenait jusqu'à
       huit cartes portant « Ne correspond pas aux activités que vous avez
       indiquées » — le titre affirmait donc l'inverse de ce que disaient
       les cartes qu'il surplombait, et 15 à 19 produits sur 23 finissaient
       à l'écran. Un outil de recommandation qui montre presque tout le
       catalogue ne recommande plus rien.

       Le repli reprend le procédé déjà utilisé plus bas pour les produits
       écartés : rien n'est caché, mais le premier écran ne montre que ce
       qui a été retenu. */
    if (ranked.others.length) {
      /* Replié quand il y a mieux à montrer ; ouvert quand c'est tout ce
         qu'il y a — sinon le message ci-dessus annoncerait un catalogue
         que rien n'affiche. */
      var othersOpen = ranked.best.length === 0 && (!ranked.packs || !ranked.packs.length);
      html += '<details class="km-others"' + (othersOpen ? ' open' : '') + '><summary>' +
        (othersOpen ? 'Le catalogue complet' : 'Voir le reste du catalogue') +
        ' (' + ranked.others.length + ')</summary>' +
        '<ul class="km-grid" role="list">' + ranked.others.slice(0, 8).map(card).join('') + '</ul>' +
        '</details>';
    }

    /* Les produits écartés pour raison de sécurité ne sont pas
       recommandés, et la raison est dite. On ne les cache pas : on
       explique pourquoi ils ne conviennent pas. */
    if (ranked.excluded.length) {
      html += '<details class="km-excluded"><summary>Non recommandés pour lui (' +
        ranked.excluded.length + ')</summary><ul role="list">' +
        ranked.excluded.map(function (r) {
          return '<li><a href="' + esc(r.product.url) + '">' + esc(r.product.shortTitle || r.product.title) +
            '</a> — ' + esc(r.match.exclusions[0].message) + '</li>';
        }).join('') + '</ul></details>';
    }

    html += '<p class="km-results__note">Aucun jouet pour chien n’est indestructible. ' +
      'Surveillez les premières utilisations et retirez tout produit endommagé.</p>';

    host.innerHTML = html;
    host.hidden = false;
    if (quiz) quiz.hidden = true;

    var visibleResultCount =
      ranked.best.length +
      ranked.others.length +
      (ranked.packs ? ranked.packs.length : 0);

    track('kroq_match_results_shown', {
      result_count: visibleResultCount
    });

    kroqTrack("results_view", {
      result_count: visibleResultCount,
      best_count: ranked.best.length,
      pack_count: ranked.packs ? ranked.packs.length : 0,
      other_count: ranked.others.length,
      excluded_count: ranked.excluded.length
    });

    host.querySelector('[data-km-edit]').addEventListener('click', function () {
      host.hidden = true;
      if (quiz) quiz.hidden = false;
      track('kroq_match_profile_edited', {});
    });
    host.querySelector('[data-km-reset]').addEventListener('click', function () {
      clearProfile();
      location.reload();
    });
    host.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-km-product]');
      if (!a) return;

      var handle = a.dataset.kmProduct;

      track('kroq_match_product_clicked', {
        handle: handle
      });

      kroqTrack("product_click", {
        product_handle: handle
      });
    });

    host.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ════════════════════════════════════════════════════════
     FICHE PRODUIT
     ════════════════════════════════════════════════════════ */
  function initPdp() {
    var host = document.querySelector('[data-km-pdp]');
    if (!host) return;

    var raw = loadProfile();
    var invite = host.querySelector('[data-km-invite]');
    var result = host.querySelector('[data-km-pdp-result]');
    if (!raw) { if (invite) invite.hidden = false; return; }

    var data = readJSON('kroq-match-product');
    if (!data || !result) { if (invite) invite.hidden = false; return; }

    var product = E.normalizeProduct(data);
    var dog = buildProfile(raw);
    var breed = findBreed(dog.breed);
    if (breed) E.attachBreedRecommendations([product], breed);

    var m = E.calculateMatch(dog, product);
    var pr = m.presentation;

    /* Aucun verdict présentable : plutôt que d'inventer un badge, la
       fiche garde l'invitation au test. Sauf si le produit est écarté
       pour raison de sécurité — là, il faut le dire. */
    if (m.rawScore == null || (pr.mode === 'none' && !m.exclusions.length)) {
      if (invite) invite.hidden = false;
      return;
    }

    var why = m.matched.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('');
    var warn = m.exclusions.concat(
      m.warnings.map(function (w) { return { message: w }; })
    ).map(function (w) { return '<li>' + esc(w.message) + '</li>'; }).join('');

    var verdict;
    if (pr.mode === 'score') {
      verdict = '<p class="km-pdp__score"><strong>' + pr.publicScore + ' %</strong> ' + esc(pr.label) + '</p>';
    } else if (pr.label) {
      verdict = '<p class="km-pdp__verdict">' + esc(pr.label) + '</p>';
    } else {
      verdict = '<p class="km-pdp__verdict">Non recommandé pour son profil</p>';
    }

    result.innerHTML =
      verdict +
      (why ? '<ul class="km-pdp__why">' + why + '</ul>' : '') +
      (warn ? '<ul class="km-pdp__warn">' + warn + '</ul>' : '');
    result.hidden = false;
    if (invite) invite.hidden = true;
  }

  /* ════════════════════════════════════════════════════════ */
  function boot() {
    var app = document.querySelector('[data-kroq-match-app]');
    if (app) {
      initQuiz(app);
      var saved = loadProfile();
      if (saved) render(saved);
    }
    initPdp();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();